module.exports = __webpack_public_path__ + "img/huace1.f28d6e74.jpg";